import React, { useEffect, useRef, useState } from "react";
import { userWithdrawList } from '../api';
import styled from "styled-components";

const WithdrawList = () => {
  const awardData = useRef([])
  const [showList, setShowList] = useState([]);
  const timer = useRef();
  const scrollPointer = useRef(1);

  const showListRef = useRef([]);
  showListRef.current = showList;

  const [finishScroll, setFinishScroll] = useState(false);

  const startScrollMsg = () => {
    setShowList([awardData.current[0]]);
    timer.current = setInterval(() => {
      const cur = awardData.current[scrollPointer.current];
      if (!cur) {
        clearInterval(timer.current);
        timer.current = null;
        setTimeout(() => setFinishScroll(true), 1000)
        return;
      }
      const next = [...showListRef.current];
      next.push(cur);
      setShowList(next);
      scrollPointer.current += 1
    }, 1000)
  }

  useEffect(() => {
    userWithdrawList({ activityId: 60 }).then(res => {
      awardData.current = res.data;
      if (Array.isArray(res.data) && res.data.length > 0) {
        startScrollMsg()
      }
    })
  }, []);

  if (finishScroll) {
    return null;
  }

  return (
    <Container>
      <div className="scroll-withdraw-container">
        <div className="scroll-wrap">
          <div className="scroll-mask-wrap">
            <div className="scroll-mask" />
            {showList.map((item, index) => {
              return (
                <div key={index} className="withdraw-item">
                  <img className="withdraw-user-avatar" src={item.userAvatar} alt=""/>
                  <span className="withdraw-user-msg">{item.message}</span>
                </div>
              )
            })}
          </div>
          
        </div>
      </div>
    </Container>
  )
}

export default React.memo(WithdrawList);

const Container = styled.div`
  height: 100%;
  display: flex;
  justify-content: flex-end;
  padding-right: 13px;

  .scroll-withdraw-container {
    height: 100%;
    overflow: hidden;
    display: inline-block;
  }
  .withdraw-item {
    height: 20px;
    display: flex;
    align-items: center;
    background: rgba(19, 20, 22, 0.57);
    opacity: 0.57;
    border-radius: 10px;
    padding: 0 10px 0 2px;
    margin-bottom: 5px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .withdraw-user-avatar {
    width: 16px;
    height: 16px;
    border-radius: 8px;
    margin-right: 6px;
  }
  .withdraw-user-msg {
    font-size: 8px;
    font-weight: 400;
    color: #FFFFFF;
  }
  .scroll-wrap {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: 100%;
  }
  .scroll-mask-wrap {
    position: relative
  }
  .scroll-mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background:  linear-gradient(0deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 100%);
    border-radius: 10px;
  }
`;


// WEBPACK FOOTER //
// ./src/views/activity_42/components/withdraw-list.js